import config from '../config/environment';
import supabase from '../config/supabase';
import { handleServiceError } from '../utils/errorHandler';
import type { PaginatedResponse, PaginationInfo } from '../types';
import type { PaymentHistoryError, PaymentHistoryErrorFilters } from '../types/payment';

export type PaginatedPaymentHistoryErrorResponse = PaginatedResponse<PaymentHistoryError>;

class PaymentHistoryErrorServiceClass {
  async listPaginated(
    page: number = 1,
    pageSize: number = 10,
    filters: PaymentHistoryErrorFilters = {},
  ): Promise<PaginatedPaymentHistoryErrorResponse> {
    const { data: sessionData } = await supabase.auth.getSession();
    const token = sessionData?.session?.access_token?.trim();

    if (!token) {
      handleServiceError(new Error('Usuária não autenticada.'), 'listar erros de pagamento');
    }

    const url = new URL(`${config.supabaseFunctionsUrl}/list-payment-history-errors`);
    url.searchParams.set('page', String(page));
    url.searchParams.set('pageSize', String(pageSize));
    if (filters.search) url.searchParams.set('search', filters.search);
    if (filters.paymentId) url.searchParams.set('paymentId', filters.paymentId);
    if (filters.provider) url.searchParams.set('provider', filters.provider);
    if (filters.dateFrom) url.searchParams.set('dateFrom', filters.dateFrom);
    if (filters.dateTo) url.searchParams.set('dateTo', filters.dateTo);

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        apikey: config.supabaseAnonKey,
      },
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      handleServiceError(
        new Error(err?.error || 'Erro ao listar erros de pagamento'),
        'listar erros de pagamento',
      );
    }

    return response.json() as Promise<PaginatedPaymentHistoryErrorResponse>;
  }
}

export const PaymentHistoryErrorService = new PaymentHistoryErrorServiceClass();

export type { PaginationInfo };
